function endingRemoval(symbolList, string) {
  if (string && symbolList.indexOf(string[string.length - 1]) > -1) {
    return endingRemoval(symbolList, string.substring(0, string.length - 1));
  }

  return string;
}

export default endingRemoval;
